import { type ChatMessageModel } from '@/shared/api'

import { type GroupMessageItem, GroupMessageType } from './feedbacks-type'

/**
 * Возвращает идентификаторы непрочитанных сообщений до указанного индекса.
 * @param messages Список сообщений группы.
 * @param readMessages Множество уже прочитанных сообщений.
 * @param currentMessageIndex Индекс, до которого искать непрочитанные сообщения (не включая его).
 */
export function getUnreadMessageIdsBeforeIndex(
  messages: GroupMessageItem[],
  readMessages: Set<string>,
  currentMessageIndex: number,
) {
  const messagesToMark: string[] = []

  for (let i = 0; i < currentMessageIndex; i++) {
    const item = messages[i]
    if (
      item.type === GroupMessageType.USER_MESSAGE &&
      !item.item.isCurrentUserMessage &&
      !item.item.isRead &&
      !readMessages.has(item.item.id)
    ) {
      messagesToMark.push(item.item.id)
    }
  }

  return messagesToMark
}

/**
 * Проверяет, является ли сообщение с данным id непрочитанным сообщением другого пользователя.
 * @param messages Список сообщений группы.
 * @param messageId Идентификатор сообщения.
 */
export function isUnreadMessageFromOtherUserById(
  messages: GroupMessageItem[],
  messageId: string,
) {
  return messages.some(
    (message) =>
      isUnreadMessageFromOtherUser(message) && message.item.id === messageId,
  )
}

export function getMessageIndex(
  messages: GroupMessageItem[],
  messageId: string,
): number {
  return messages.findIndex(
    (message) =>
      message.type === GroupMessageType.USER_MESSAGE &&
      message.item.id === messageId,
  )
}

export function isUnreadMessageFromOtherUser(
  message: GroupMessageItem,
): message is { type: GroupMessageType.USER_MESSAGE; item: ChatMessageModel } {
  return (
    message.type === GroupMessageType.USER_MESSAGE &&
    !message.item.isCurrentUserMessage &&
    !message.item.isRead
  )
}
